import { render, staticRenderFns } from "./client-view.vue?vue&type=template&id=029a5b75&scoped=true"
import script from "./client-view.vue?vue&type=script&lang=js"
export * from "./client-view.vue?vue&type=script&lang=js"
import style0 from "./client-view.vue?vue&type=style&index=0&id=029a5b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029a5b75",
  null
  
)

export default component.exports